import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Features from "./components/Features";
import Cities from "./components/Cities";
import Groups from "./components/Groups";
import ChatRooms from "./components/ChatRooms";
import Matching from "./components/Matching";
import Stories from "./components/Stories";
import Safety from "./components/Safety";
import Faq from "./components/Faq";
import JoinCta from "./components/JoinCta";
import Footer from "./components/Footer";
import Reveal from "@/components/feature/Reveal";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-sans">
      <Navbar />
      <main>
        <Hero />
        <Reveal>
          <Features />
        </Reveal>
        <Reveal>
          <Cities />
        </Reveal>
        <Reveal>
          <Groups />
        </Reveal>
        <Reveal>
          <ChatRooms />
        </Reveal>
        <Reveal>
          <Matching />
        </Reveal>
        <Reveal>
          <Stories />
        </Reveal>
        <Reveal>
          <Safety />
        </Reveal>
        <Reveal>
          <Faq />
        </Reveal>
        <Reveal>
          <JoinCta />
        </Reveal>
      </main>
      <Footer />
    </div>
  );
}